/** EDEKA brand tokens aligned with @edekait/b2c-design-system BasicColors. */
export const edekaColors = {
  blueActive: '#1875D4',
  blue: '#1B66B3',
  yellow: '#FCE531',
  textPrimary: '#343638',
  textSecondary: '#676767',
  white: '#FFFFFF',
  greyWhite: '#F7F7F7',
  warning: '#FF9F00',
  error: '#DE1C12',
  success: '#83BB6F',
  paybackBg: '#CCE6FF',
} as const;

export const edekaFontFamilies = {
  text: 'EDEKAText-Regular, "Helvetica Neue", Helvetica, Arial, sans-serif',
  textBold: 'EDEKAText-Bold, "Helvetica Neue", Helvetica, Arial, sans-serif',
  headline: 'EDEKAHead-Black, "Helvetica Neue", Helvetica, Arial, sans-serif',
} as const;
